import Vue from 'vue';
import Vuex from 'vuex';
import soundtrack from '../assets/audio/soundtrack.mp3';
import win from '../assets/audio/win.mp3';
import lost from '../assets/audio/lost.mp3';
import intro from '../assets/audio/intro.mp3';
import inputType from '../assets/audio/inputType.mp3';
import hint from '../assets/audio/hint.mp3';
import hover from '../assets/audio/hover.mp3';
import switcherIn from '../assets/audio/switcherIn.mp3';
import switcherOut from '../assets/audio/switcherOut.mp3';
import synonym from '../assets/audio/synonym.mp3';
import sad from '../assets/audio/sad.mp3';
import endgame from '../assets/audio/endgame.mp3';
import ding1 from '../assets/audio/ding1.mp3';
import ding2 from '../assets/audio/ding2.mp3';
import ding3 from '../assets/audio/ding3.mp3';
import error from '../assets/audio/error.mp3';
import yooo from '../assets/audio/yooo.mp3';
import tititi from '../assets/audio/tititi.mp3';
import urra from '../assets/audio/urra.mp3';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    backgroundColor: 'blue',
    currentKey: false,
    endRound: false,
    endGame: false,
    difficult: 0,
    gamemode: false,
    players: [],
    isPreCounting: false,
    soundsStatus: false,
    dictionaryRaw: false,
    dictionary: false,
    currentPlayer: 0,
    sounds: {
      intro: new Audio(intro),
      soundtrack: new Audio(soundtrack),
      win: new Audio(win),
      lost: new Audio(lost),
      inputType: new Audio(inputType),
      hint: new Audio(hint),
      hover: new Audio(hover),
      switcherIn: new Audio(switcherIn),
      switcherOut: new Audio(switcherOut),
      synonym: new Audio(synonym),
      sad: new Audio(sad),
      endgame: new Audio(endgame),
      ding1: new Audio(ding1),
      ding2: new Audio(ding2),
      ding3: new Audio(ding3),
      error: new Audio(error),
      yooo: new Audio(yooo),
      tititi: new Audio(tititi),
      urra: new Audio(urra),
  }
  },
  mutations: {
		updateProperty(state, { property, value }) {
			state[property] = value;
		},
	},
	actions: {
		updateProperty(context, { property, value }) {
			context.commit('updateProperty', { property, value });

		},
	},
  modules: {
  }
})
